const isSafari = () => {
  if (typeof window !== 'object') return false;
  return /^((?!chrome|android).)*safari/i.test(navigator?.userAgent || '');
};
export default isSafari;
